// Tab dei coupon
import React from 'react';
import PropTypes from 'prop-types';
import { get } from './Storage';
import axios from 'axios';
import CircularProgress from 'material-ui/CircularProgress';
import * as Colors from 'material-ui/styles/colors';
import { Message } from "mgUiKit";
import WidgetCoupon from './Widget/Coupon';
import WidgetCasinoPromotion from './Widget/CasinoPromotion';
import WidgetFreebets from './Widget/Freebets';
import WidgetFunbonus from './Widget/Funbonus';
import KeepAlive from './KeepAlive';
import DepositByEcoupon from './DepositToolsList/DepositByEcoupon';

// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'TabCouponComponent';

var styles = AppSettings.styles;

class TabCoupon extends React.Component {
    constructor(props, context) {
        super(props);
        this.state = {
            coupons: [],
            casinoPromotions: [],
            freebets: [],
            funbonus: [],
            total: 0,
            assignedFreebet: new Map(),
            error: false,
            showLoading: true,
            errorMessage: "",
            render: false,
            filter: "",          
            startX: 0,
            scrollLeft: 0,
            isDown: false,                  
            couponFeed:{
                typeMessage: "info",
                message: ""
            }
        }

        this.sliderRef = null;
        
        this.loadTabCoupon = this.loadTabCoupon.bind(this);
        this.callbackAddCoupon = this.callbackAddCoupon.bind(this);
        this.callbackFeedback = this.callbackFeedback.bind(this);
        this.setFilter = this.setFilter.bind(this);

        this.handleMouseDown = this.handleMouseDown.bind(this);
        this.handleMouseLeave = this.handleMouseLeave.bind(this);
        this.handleMouseUp = this.handleMouseUp.bind(this);
        this.handleMouseMove = this.handleMouseMove.bind(this);
    }

    componentDidMount() {
        this.loadTabCoupon();
    }

    setSliderRef = (element) => {
        self.sliderRef = element;
        if (self.sliderRef) {
          this.addSliderEvents();
        } else {
          this.removeSliderEvents();
        }
      }

    addSliderEvents = () => {
        const slider = self.sliderRef;
        if (slider) {
          slider.addEventListener('mousedown', this.handleMouseDown);
          slider.addEventListener('mouseleave', this.handleMouseLeave);
          slider.addEventListener('mouseup', this.handleMouseUp);
          slider.addEventListener('mousemove', this.handleMouseMove);
        }
      }
    
    removeSliderEvents = () => {
        const slider = self.sliderRef;
        if(slider != null){
            slider.removeEventListener('mousedown', this.handleMouseDown);
            slider.removeEventListener('mouseleave', this.handleMouseLeave);
            slider.removeEventListener('mouseup', this.handleMouseUp);
            slider.removeEventListener('mousemove', this.handleMouseMove);
        }
    }


    handleMouseDown = (e) => {
        const slider = self.sliderRef;
        if (slider) {
            this.setState({
            isDown: true,
            startX: e.pageX - slider.offsetLeft,
            scrollLeft: slider.scrollLeft
            });
            slider.classList.add('active');
        }
    }
    
    handleMouseLeave = () => {
        const slider = self.sliderRef;
        if (slider) {
            this.setState({ isDown: false });
            slider.classList.remove('active');
        }
    }
    
    handleMouseUp = () => {
        const slider = self.sliderRef;
        if (slider) {
            this.setState({ isDown: false });
            slider.classList.remove('active');
        }
    }
    
    handleMouseMove = (e) => {
        const slider = self.sliderRef;
        if (this.state.isDown && slider) {
          e.preventDefault();
          const x = e.pageX - slider.offsetLeft;
          const walk = (x - this.state.startX) * 1;
          //slider.scrollLeft = this.state.scrollLeft - walk;
          slider.scrollLeft = Math.max(0, this.state.scrollLeft - walk);
        }
    }


    loadTabCoupon() {
        this.setState({
            showLoading: true,
            render: false
        });
        var url = AppSettings['env'].urlUserBoxTabCoupon;
        axios.get(url)
            .then(({ data, status, statusText }) => {
                if (data.errors.length == 0) {

                    let today = new Date();
                    let enddate = today.format("dd-MM-yyyy");
                    let startdate = (new Date(today.getFullYear(), today.getMonth(), today.getDate() - 14)).format("dd-MM-yyyy");
                
                    let request = {
                        request:{
                            "startDate": startdate,
                            "endDate": enddate,
                            "type": 0,
                            "limit": 20,
                            "sessionToken": ""
                        }
                    };
                    axios.post(AppSettings['env'].urlAssignedFreebet, request)
                        .then(({ data, status, statusText }) => { 
                            if (data.errors.length == 0) {
                                let assignedFreebet = new Map();
                                for(let index = 0; index < data.data.length;index++){
                                    let ass = data.data[index];
                                    assignedFreebet.set(ass.code, ass);
                                }
                                this.setState({
                                    assignedFreebet: assignedFreebet,
                                    render: true
                                });
                            }

                        })
                        .catch(error => { 
                            this.setState({
                                assignedFreebet: new Map(),
                                render: true
                            });
                        });

                    // numero totale delle promozioni
                    let numCoupon = 0;
                    if(data.coupons != null && typeof data.coupons != 'undefined'){
                        numCoupon += data.coupons.length;
                    }
                    else{
                        data.coupons = [];
                    }

                    if(data.casinoPromotions != null && typeof data.casinoPromotions != 'undefined'){
                        numCoupon += data.casinoPromotions.length;
                    }
                    else{
                        data.casinoPromotions = [];
                    }

                    if(data.funbonus != null && typeof data.funbonus != 'undefined'){
                        numCoupon += data.funbonus.length;
                    }
                    else{
                        data.funbonus = [];
                    }

                    if(data.freebets != null && typeof data.freebets != 'undefined'){
                        numCoupon += data.freebets.length;
                    }
                    else{
                        data.freebets = [];
                    }
                    this.context.updateToolbarCount("coupon", numCoupon);
                    this.context.updateTabsCount("coupon", numCoupon);

                    this.setState({
                        coupons: data.coupons,
                        casinoPromotions: data.casinoPromotions,
                        freebets: data.freebets,
                        assignedFreebet:new Map(),
                        funbonus: data.funbonus,
                        total: numCoupon,
                        error: false,
                        showLoading: false,
                        errorMessage: "",
                        render: true,
                        
                    });
                } else {
                    this.setState({
                        error: true,
                        showLoading: false,
                        errorMessage: <KeepAlive />,
                        render: true,
                        coupons: [],
                        casinoPromotions: [],
                        freebets: [],
                        funbonus: [],
                        total: 0,
                        assignedFreebet: new Map(),
                    });

                }
            })

            .catch((error) => {
                this.setState({
                    error: true,
                    showLoading: false,
                    errorMessage: "",
                    render: true,
                    casinoPromotions: [],
                    freebets: [],
                    funbonus: [],
                    assignedFreebet: new Map(),

                });
            });
    }

    renderPromotions() {
        if(!AppSettings['perms'].promotions){
            return "";
        }
        if(this.state.filter != "" && this.state.filter != "casinopromotion"){
            return "";
        }

        if(this.state.filter == "casinopromotion" && this.state.casinoPromotions.length == 0){
            return(<span>Il filtro applicato non ha prodotto risultati</span>);
        }

        var promotions = "";
        if (this.state.casinoPromotions.length > 0) {
            promotions = this.state.casinoPromotions.map(function (promotion, i) {               
                var key = "casino_promo_"+promotion.id;                
                return <WidgetCasinoPromotion key={key} data={promotion} />;                    
            });
        }
        else {
            return;
        }

        return (
            <>
                {promotions}
            </>
        );
    }

    callbackAddCoupon(){
        this.loadTabCoupon();
    }

    callbackFeedback(feed){
        this.setState({couponFeed:feed});
    }

    renderCoupon() {
        if(this.state.filter != "" && this.state.filter != "coupon"){
            return "";
        }

        if(this.state.filter == "coupon" && this.state.coupons.length == 0){
            return(<span>Il filtro applicato non ha prodotto risultati</span>);
        }
        return (
            <>
                {(() => {
                    var coupons = "";
                    if (this.state.coupons.length > 0) {
                        coupons = this.state.coupons.map(function (coupon, i) {
                            var key = coupon.key+ "_" + i;
                            return (
                                <WidgetCoupon key={key} data={coupon} />
                            )
                        });
                        return (
                            <>
                                {coupons}
                            </>
                        )
                    }
                   
                })()}
            </>
        )
    }

    renderFunBets() {
        if(this.state.filter != "" && this.state.filter != "freebet"){
            return "";
        }

        if(typeof this.state.freebets == null){
            return null;
        }

        if(this.state.filter == "freebet" && this.state.freebets.length == 0){
            return(<span>Il filtro applicato non ha prodotto risultati</span>);
        }

        return (
            <>

                {(() => {
                    var freebetsList = "";
                    let assignedFreebet = this.state.assignedFreebet;
                    if (this.state.freebets.length > 0) {
                        freebetsList = this.state.freebets.map(function (freebet, i) {
                            freebet['assigned'] = null;
                            if(assignedFreebet.has(freebet.Code)){
                                freebet.assigned = assignedFreebet.get(freebet.Code);
                            }
                            var key = freebet.Code;
                            return (
                                <WidgetFreebets key={key} data={freebet} />
                            )
                        });
                        return (
                            <>
                                {freebetsList}
                            </>
                        )
                        /*

                        return (
                            <div className="mg-coupon-list mg-freebets-list">
                                {freebetsList}
                            </div>
                        )*/
                    } 
                })()}
            </>
        )
    }

    renderFunbonus(){
        if(this.state.filter != "" && this.state.filter != "funbonus"){
            return "";
        }
        if (typeof this.state.funbonus != 'object' || this.state.funbonus == undefined) {
            return null;
        }

        if(this.state.filter == "funbonus" && this.state.funbonus.length == 0){
            return(<span>Il filtro applicato non ha prodotto risultati</span>);
        }

        return (
            <>
                {(() => {
                    var funbonusList = "";
                    if (this.state.funbonus.length > 0) {
                        funbonusList = this.state.funbonus.map(function (funbonus, i) {
                            var key = funbonus.Code;
                            return (
                                <WidgetFunbonus key={key} data={funbonus} />
                            )
                        });
                        return (
                            <>
                                {funbonusList}
                            </>
                        )                        
                    }
                   
                })()}
            </>
        )
    }

    setFilter(index) {

        this.setState({
            filter: index
        });
    };


    renderFilterV2() {
        //controllo quanti filtri sono attivi 
        let activeFilterCounter = 0;

        let couponsIcon = "";
        if (this.state.coupons.length > 0) {
            activeFilterCounter += 1;
            couponsIcon =
                        <li className={`promo-coupon${this.state.filter == "coupon" ? " active" : ""}`} onClick={() => this.setFilter("coupon")}>
                            <span className="widget-filter--label">
                                <i className="widget-filter--icon"></i>
                                Coupon
                            </span>
                            <span className="widget-filter--counter">{this.state.coupons.length}</span>
                        </li>
        }

        let freebetIcon = "";
        if (this.state.freebets.length > 0) {
            activeFilterCounter += 1;
            freebetIcon =  
                        <li className={`promo-freebet${this.state.filter == "freebet" ? " active" : ""}`} onClick={() => this.setFilter("freebet")}>
                            <span className="widget-filter--label">
                                <i className="widget-filter--icon"></i>
                            Freebet
                            </span>
                            <span className="widget-filter--counter">{this.state.freebets.length}</span>
                        </li>
        }

        let funbonusIcon = "";
        if (this.state.funbonus.length > 0) {
            activeFilterCounter += 1;
            funbonusIcon =    
                        <li className={`promo-funbonus${this.state.filter== "funbonus" ? " active" : ""}`} onClick={() => this.setFilter("funbonus")}>
                            <span className="widget-filter--label">
                                <i className="widget-filter--icon"></i>
                                Fun bonus
                            </span>
                            <span className="widget-filter--counter">{this.state.funbonus.length}</span>
                        </li>;
        }

        let casinoPromotionsIcon = "";
        if (this.state.casinoPromotions.length > 0) {
            activeFilterCounter += 1;
            casinoPromotionsIcon =
                            <li className={`promo-casinopromotion${this.state.filter == "casinopromotion" ? " active" : ""}`} onClick={() => this.setFilter("casinopromotion")}>
                            <span className="widget-filter--label">
                                <i className="widget-filter--icon"></i>
                                Freerounds
                            </span>
                            <span className="widget-filter--counter">{this.state.casinoPromotions.length}</span>
                        </li>;
        }

        let allCouponIcon =  <li className={`promo-all${this.state.filter == "" ? " active" : ""}`} onClick={() => this.setFilter("")}>
                                <span className="widget-filter--label">
                                    <i className="widget-filter--icon"></i>
                                    Tutte
                                </span>
                            </li>
        
        if(activeFilterCounter > 1){
            return (
                <div className="widget-filter" id="widget-filter_bonus">
                    <ul className="widget-filter--list" ref={this.setSliderRef}>
                        {allCouponIcon}
                        {couponsIcon}
                        {freebetIcon}
                        {funbonusIcon}
                        {casinoPromotionsIcon}
                    </ul>
                </div>
            );
        }else{
            return(
                <>
                </>
            );
        }

    }
 
    renderFilter() {
        //controllo quanti filtri sono attivi 
        let activeFilterCounter = 0;

        var couponsIcon = "";
        if (this.state.coupons.length > 0) {
            activeFilterCounter += 1;
            let icon = JSON.parse(JSON.stringify(styles.topFilterIconStyle));
            icon['color'] = Colors.blue500;
            icon['opacity'] = "0.7"; 
            if (this.state.filter == "coupon") {
                icon['opacity'] = "1.0"; 
            }
            let filerBadgeStyle = JSON.parse(JSON.stringify(styles.filerBadgeStyle));
            filerBadgeStyle['backgroundColor'] = Colors.blue500;
            couponsIcon =
                    <a id="mg-promo-icon" title="Visualizza solo coupon" onClick={() => this.setFilter("coupon")}>
                        <i className='fa-mg fa-mg-promo'></i><sup>{this.state.coupons.length}</sup>
                    </a>;
        }

        var freebetIcon = "";
        if (this.state.freebets.length > 0) {
            activeFilterCounter += 1;
            let icon = JSON.parse(JSON.stringify(styles.topFilterIconStyle));
            icon['opacity'] = "0.7"; 
            icon['color'] = Colors.red900;
            if (this.state.filter == "freebet") {
                icon['opacity'] = "1.0"; 
            }
            let filerBadgeStyle = JSON.parse(JSON.stringify(styles.filerBadgeStyle));
            filerBadgeStyle['backgroundColor'] = Colors.red900;
            freebetIcon =  
                    <a id="mg-freebet-icon" title="Visualizza solo freebet" onClick={() => this.setFilter("freebet")}>
                        <i></i><sup>{this.state.freebets.length}</sup>
                    </a>;
        }

        var funbonusIcon = "";
        if (this.state.funbonus.length > 0) {
            activeFilterCounter += 1;
            let icon = JSON.parse(JSON.stringify(styles.topFilterIconStyle));
            icon['color'] = "#bfb900";
            icon['opacity'] = "0.7"; 
            if (this.state.filter == "funbonus") {
                icon['opacity'] = "1.0"; 
            }
            let filerBadgeStyle = JSON.parse(JSON.stringify(styles.filerBadgeStyle));
            filerBadgeStyle['backgroundColor'] = "#bfb900";
            funbonusIcon =    
                        <a id="mg-funbonus-icon" title="Visualizza solo funbonus" onClick={() => this.setFilter("funbonus")}>
                            <i></i><sup>{this.state.funbonus.length}</sup>
                        </a>;
        }

        var casinoPromotionsIcon = "";
        if (this.state.casinoPromotions.length > 0) {
            activeFilterCounter += 1;
            let icon = JSON.parse(JSON.stringify(styles.topFilterIconStyle));
            icon['color'] = Colors.green900;
            icon['opacity'] = "0.7"; 
            if (this.state.filter == "casinopromotion") {
                icon['opacity'] = "1.0"; 
            }
            let filerBadgeStyle = JSON.parse(JSON.stringify(styles.filerBadgeStyle));
            filerBadgeStyle['backgroundColor'] = Colors.green900;
            casinoPromotionsIcon =
                            <a id="mg-freerounds-icon" title="Visualizza solo freerounds" onClick={() => this.setFilter("casinopromotion")}>
                                <i></i><sup>{this.state.casinoPromotions.length}</sup>
                            </a>;
        }


        var iconStyleAbort = JSON.parse(JSON.stringify(styles.topFilterIconStyle));
        iconStyleAbort['color'] = Colors.grey500
        iconStyleAbort['opacity'] = "1.0"; 


        var allCouponIcon = <i className='fa fa-times' title="Rimuovi filtri"  onClick={() => this.setFilter("")}></i>
        
            if(activeFilterCounter > 1){
                return (
                    <div id="bar-bet-icons">
                        {couponsIcon}
                        {freebetIcon}
                        {funbonusIcon}
                        {casinoPromotionsIcon}
                        {allCouponIcon}
                    </div>
                );
            }else{
                return(
                    <>
                    </>
                );
            }

    }

    render() {
        if(!this.state.render){
            return (
                <div key="coupon_area">
                    {this.state.showLoading ?
                        <CircularProgress key="progress" style={styles.loadingIcon} />
                    :  null}
                </div>
            );
            
        }
        else{
             // var clickEventReportCoupon = (e) => {
            //     this.context.openLinkPopup(e, AppSettings["homeRealm"] + "Report/Ecoupon.aspx");
            // }
            return (
                <div key="coupon_area">
                    {/* {this.state.showLoading ?
                        <CircularProgress key="progress" style={styles.loadingIcon} />
                    :  null} */}
                    {this.state.error ?
                        <Message key="msg" type="error">{this.state.errorMessage}</Message>
                    : null}
                    {this.state.couponFeed.message != "" ?
                        <Message key={"feed-" + Math.random()} type={this.state.couponFeed.typeMessage}>{this.state.couponFeed.message}</Message> : null }
                        {
                            this.state.total > 0 &&
                                <>
                                    {this.renderFilter()}
                                    {this.renderFilterV2()}
                                    <div className="mg-coupon-list">
                                        {this.renderCoupon()}
                                        {this.renderPromotions()}
                                        {this.renderFunbonus()}
                                        {this.renderFunBets()}
                                    </div>
                                </>
                        }
                    <div id="mg-ecoupon-actions" className="mg-user-widget">
                        <DepositByEcoupon successCallback={this.callbackAddCoupon}  onFeedCallback={this.callbackFeedback}/>                       
                    </div>
                </div>
            );
        }
    }
}

TabCoupon.displayName = componentName;

// PropTypes validation
TabCoupon.propTypes = {};

// default props
TabCoupon.defaultProps = {};

TabCoupon.contextTypes = {
    updateToolbarCount: PropTypes.func,
    updateTabsCount: PropTypes.func


}

export default TabCoupon;